<template>
  <div class="d-flex align-items-center justify-content-center overflow-auto">
    <img
      v-if="fileReady"
      :src="`${file.link}?w=1200`"
      :style="{
        'max-width': $store.state.app.isMobile ? '100% !important' : 'inherit'
      }"
    />
  </div>
</template>
<script>
import { fileInheritedDetail } from "@/api/media";

export default {
  name: "detail",
  props: {
    propFileId: {
      type: Number,
      default: () => null
    }
  },
  data() {
    return {
      fileReady: false,
      file: {},
      deletingFileId: 0
    };
  },

  mounted() {
    this.init();
  },
  methods: {
    init() {
      let _id = this.propFileId;
      if (_id == undefined) {
        _id = this.$route.params.id;
      }

      fileInheritedDetail({ params: { id: _id }, store: this.$store }).then(
        res => {
          if (res != false) {
            this.file = res.data.file;
            this.fileReady = true;
            this.$nextTick(() => {
              this.$emit("on-img-loaded", res.data.file);
            });
          }
        }
      );
    }
  }
};
</script>
